import { render, staticRenderFns } from "./Screensaver.vue?vue&type=template&id=47a9485e&"
import script from "./Screensaver.vue?vue&type=script&lang=js&"
export * from "./Screensaver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports